import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from 'app/types/entity';
import { Question, IQuestion } from 'app/constants/schemas/Question';
import { Section, ISection } from 'app/constants/schemas/Section';

type QuestionSectionType = ISection & {
  associations: {
    question: IQuestion[];
  };
};

export type QuestionSection = Entity<QuestionSectionType>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSection: IEntityType<QuestionSectionType> = vmClient.defineClass({
  typeName: 'QuestionSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  associations: {
    questions: [Question],
  },
});
